<div style="text-align: center">
  <div style="font-size: 36px; font-weight: 600">
    <adp-label labelKey="Deductible_Lookup_Device_Header"></adp-label>
  </div>
</div>

<div class="mt-30 mb-30" style="border: 1px solid #dbe1e2">
  <div
    class="mat-mdc-header-row"
    [ngStyle]="{ 'border-bottom': isDesktopView ? 'none' : '', padding: !isDesktopView ? '10px' : '' }"
    style="text-align: left">
    <div class="mat-mdc-header-cell" style="padding-left: 20px; padding-right: 20px">
      <div class="mt-20 mr-10">
        <button mat-stroked-button color="accent" type="button" class="back-button" (click)="handleClick()" [gtmClick]="getViewLabel('Deductible_New_Lookup_Button')">
          <mat-icon class="device-lookup-icon" [svgIcon]="'device-lookup'"></mat-icon>
          <adp-label [labelKey]="'Deductible_New_Lookup_Button'" style="font-size: 14px"></adp-label>
        </button>
      </div>

      <div class="mt-40">
        <adp-label [labelKey]="'Deductible_Results_Subheading'" style="font-size: 14px"></adp-label>
      </div>

      <div class="mt-10" style="font-size: 24px">
        {{ lookupResults.deviceName }}
      </div>

      <div class="mt-10">
        <div class="tier-box">
          {{ lookupResults.tier }}
        </div>
      </div>
      <div class="mt-10">
        <hr />
      </div>
    </div>
  </div>

  <div class="mt-10 mb-10 ml-20" style="font-size: 18; font-weight: 600">Xfinity Total Device Protection</div>

  <div class="mat-mdc-row">
    <table class="mat-mdc-table">
      <thead>
        <tr style="text-align: left; background-color: #f2f2f2; color: #596981; border-bottom: 1px solid #dbe1e2">
          <th style="width: 50%">
            <div style="min-width: 180px; font-weight: 600; font-size: 16px; min-height: 40px; padding-left: 12px; padding-top: 10px">
              <adp-label labelKey="Deductible_Lookup_Results_ClaimType_Title"></adp-label>
            </div>
          </th>
          <th style="width: 50%">
            <div
              style="
                font-weight: 600;
                font-size: 16px;
                min-height: 40px;
                padding-left: 12px;
                padding-top: 10px;
                border-right: 1px solid #dbe1e2;
                border-left: 1px solid #dbe1e2;
              ">
              <adp-label labelKey="Deductible_Lookup_Results_ServiceFee_Title"></adp-label>
            </div>
          </th>
        </tr>
      </thead>

      <tbody *ngIf="isDesktopView || !isDesktopView">
        <tr class="mat-mdc-cell" *ngFor="let item of lookupResults.protections">
          <td style="padding-left: 12px; min-height: 40px; border-bottom: 1px solid #dbe1e2">
            {{ item.claimType }}
          </td>
          <td
            style="
              overflow: visible !important;
              border-bottom: 1px solid #dbe1e2;
              padding: 15px;
              min-height: 40px;
              border-left: 1px solid #dbe1e2;
            ">
            {{ item.fee | currency: 'USD' : 'symbol' : '1.0-0' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mt-20 mb-10 ml-30" style="font-size: 18; font-weight: 600">Xfinity Total Device Protection Plus</div>

  <div class="mat-mdc-row mb-20">
    <table class="mat-mdc-table">
      <thead>
        <tr style="text-align: left; background-color: #f2f2f2; color: #596981; border-bottom: 1px solid #dbe1e2">
          <th style="width: 50%">
            <div
              style="
                min-width: 180px;
                font-weight: 600;
                height: 100%;
                font-size: 16px;
                min-height: 40px;
                padding-left: 12px;
                padding-top: 10px;
              ">
              <adp-label labelKey="Deductible_Lookup_Results_ClaimType_Title"></adp-label>
            </div>
          </th>
          <th style="width: 50%">
            <div
              style="
                font-weight: 600;
                font-size: 16px;
                min-height: 40px;
                padding-left: 12px;
                padding-top: 10px;
                border-right: 1px solid #dbe1e2;
                border-left: 1px solid #dbe1e2;
              ">
              <adp-label labelKey="Deductible_Lookup_Results_ServiceFee_Title"></adp-label>
            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr class="mat-mdc-cell" *ngFor="let item of lookupResults.protectionsPlus">
          <td style="padding-left: 12px; min-height: 40px; border-bottom: 1px solid #dbe1e2">
            {{ item.claimType }}
          </td>
          <td
            style="
              overflow: visible !important;
              border-bottom: 1px solid #dbe1e2;
              padding: 15px;
              min-height: 40px;
              border-left: 1px solid #dbe1e2;
            ">
            {{ item.fee | currency: 'USD' : 'symbol' : '1.0-0' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mt-20 ml-20 mr-20 mb-30 faq-list-container">
    <mat-accordion *ngIf="faqListItems?.length > 0">
      <mat-expansion-panel
        displayMode="flat"
        hideToggle
        *ngFor="let faqItem of faqListItems; let i = index"
        (opened)="setOpened(i)"
        (closed)="setClosed(i)"
        class="faq-item-container"
        [gtmClick]="getViewLabel(faqItem.questionKey)"
        gtmEventCategory="accordion_expand"
        [gtmLinkClasses]="getViewLabel('Deductible_Lookup_Device_Header')">
        <mat-expansion-panel-header class="faq-question-container">
          <mat-panel-title>
            <mat-icon class="faq-icon-container" [svgIcon]="currentlyOpenedItemIndex === i ? 'subtract' : 'add'"></mat-icon>
            <span class="faq-question"><adp-label labelKey="{{ faqItem.questionKey }}"></adp-label></span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="faq-answer-container">
          <div class="faq-answer"><adp-label labelKey="{{ faqItem.answerKey }}"></adp-label></div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
